<div [formGroup]="pwdReset" class="page-layout-container">
    <div class="title-group">
        <h1>Updated Password </h1>
    </div>

    <div *ngIf="successFlag" class="alert alert-success">{{ message }}</div>

    <div class="row">
        <div class="col" style="width: 30%;">
            <mat-form-field>
                    <mat-label>User Name</mat-label>
                    <input matInput readonly="true" formControlName="userName">
                </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <mat-form-field class="example-full-width">
                <mat-label>Old Password *</mat-label>
                <input type="password" matInput formControlName="oldPwd">
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <mat-form-field class="example-full-width">
                <mat-label>New Password *</mat-label>
                <input type="password" matInput formControlName="newPwd">
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <mat-form-field class="example-full-width">
                <mat-label>Reenter Password *</mat-label>
                <input type="password" matInput formControlName="reEnterNewPwd">
            </mat-form-field>
        </div>
    </div>
    <div style="text-align: center">
        <button mat-button [disabled]="!pwdReset.valid" (click)="resetPwd()" type="submit">Reset Password</button>
    </div>
</div>
